import { FeatureFlagCapability } from '@doxyme/extensions-bridge';
import { useAddCapability } from '@doxyme/extensions-bridge-react';
import { useEffect } from 'react';

import { bridge } from '../../../features/extensions/instances';
import { resolveGrowthBookFeature } from '../../../shared/growthBook/resolveGrowthBookFeature';

/**
 * Hook responsible for adding feature flag capability
 * and providing handlers responsible for getting the value of a feature flag
 * from the growthBook instance
 */
export function useExtensionsFeatureFlag(): void {
  const featureFlag = useAddCapability(
    bridge,
    () => new FeatureFlagCapability(),
  );

  useEffect(() => {
    const unsubscribe = featureFlag.onGet(resolveGrowthBookFeature);

    return () => {
      unsubscribe();
    };
  }, []);
}
